/* global analytics */
import $ from 'jquery';

export const timeout = {};
export const trigger = (data, callback) => {

    if (data instanceof Array) {
        $.each(data, function (i) {
            if(i < (data.length - 1)) {
                triggerEvents(data[i]);
            }
            else {
                triggerEvents(data[i], callback);
            }
        });
    } else {
        triggerEvents(data, callback);
    }
};
export const triggerEvents = (data, callback) => {
    var event = data.event,
        properties = data.properties;

    console.log(data);
    if (typeof analytics === 'undefined') {
        console.warn('Analytics is undefined');
        if(typeof(callback) != 'undefined') {
            callback();
        }
        return;
    }

    if(typeof(callback) != 'undefined' && callback) {
        console.log('Triggering event with callback');
        analytics.track(event, properties, {}, callback);
    }
    else {
        console.log('Triggering event without callback');
        analytics.track(event, properties);
    }
};
export const createEvents = ($trigger, data) => {
    var triggerKey = data.trigger + '.segmenttracking';

    $trigger.off(triggerKey);
    $trigger.on(triggerKey, function () {
        trigger(data);
    });
};
export const create = ($trackers) => {
    $trackers.each(function () {
        var $el = $(this),
            rawData = $el.data('segment-tracking'),
            data = (typeof(rawData == 'object')) ? rawData : JSON.parse($el.data('segment-tracking'));

        if (data instanceof Array) {
            $.each(data, function (i) {
                createEvents($el, data[i]);
            });
        } else {
            createEvents($el, data);
        }
    });
};
export const init = ($el) => {
    var $trackers = $el || $('[data-segment-tracking]');

    create($trackers);
};
export const binds = () => {
    init();
};
